import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CompanyCollectorResponseDto } from '@domain/company-collector/dtos/company-collector.response.dto';
import { CreateCompanyCollectorRequestDto } from '@domain/company-collector/dtos/create-company-collector.request.dto';
import { ListCompanyCollectorRequestDto } from '@domain/company-collector/dtos/list-company-collector.request.dto';
import { UpdateStateCompanyCollectorRequestDto } from '@domain/company-collector/dtos/update-state-company-collector.request.dto';
import { RefId } from '@core/interface/ref-id.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { CompanyCollectorAdditionalChargeResponseDto } from '@domain/company-collector/dtos/company-collector-additional-charge.response.dto';
import { UpdateCompanyCollectorAdditionalChargeRequestDto } from '@domain/company-collector/dtos/update-company-collector-additional-charge.request.dto';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('company/collector');
  }

  create(request: CreateCompanyCollectorRequestDto) {
    const queryUrl = `${this.getApiUrl()}`;
    return this.http.post<ApiResponse<CompanyCollectorResponseDto>>(
      queryUrl,
      request,
    );
  }

  show(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/show/${request.refId}`;
    return this.http.get<ApiResponse<CompanyCollectorResponseDto>>(queryUrl);
  }

  list(request: ListCompanyCollectorRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<CompanyCollectorResponseDto>>
    >(queryUrl, {
      params: { ...request },
    });
  }

  updateState(request: UpdateStateCompanyCollectorRequestDto) {
    const queryUrl = `${this.getApiUrl()}/${request.refId}/state`;
    return this.http.patch<ApiResponse<CompanyCollectorResponseDto>>(
      queryUrl,
      request,
    );
  }

  showAdditionalCharges(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/additional-charge/show/${request.refId}`;
    return this.http.get<
      ApiResponse<CompanyCollectorAdditionalChargeResponseDto>
    >(queryUrl);
  }

  // Reemplaza COMPLETO el arreglo de cargos del procesador (mismo patrón
  // embebido que el PUT del tarifario: enviarlo vacío borra todos).
  updateAdditionalCharges(request: UpdateCompanyCollectorAdditionalChargeRequestDto) {
    const queryUrl = `${this.getApiUrl()}/additional-charge/${request.refId}`;
    return this.http.put<
      ApiResponse<CompanyCollectorAdditionalChargeResponseDto>
    >(queryUrl, { additionalCharges: request.additionalCharges });
  }
}
